import { z } from 'zod';

export const ProductDetailPromotionDTO = z
    .union([z.literal('STANDARD'), z.literal('OMNIBUS'), z.literal('REGULAR')])
    .nullish();
